export default __webpack_public_path__ + "static/media/obj4.5387c61a.jpg";